<template>
  <nav class="top-nav-bar">
    <div class="nav-left">
      <div class="logo">
        <router-link to="/"><img src="@/assets/logo/logo.png" alt="logo" style="width: 50px;"></router-link>
      </div>
      <div class="divider"></div>
      <ul class="nav-links">
        <li><router-link to="/">主页</router-link></li>
        <li><router-link to="/bank-list">题库</router-link></li>
        <li><router-link to="/daily-question-calendar">每日刷题</router-link></li>
        <!-- <li><router-link to="/about">关于我们</router-link></li> -->
      </ul>
    </div>
    <div class="user-icon" 
         @click="isLoggedIn ? toggleUserMenu() : showLogin()">
      <div class="user-icon-container">
        <svg class="icon" :class="{ 'not-logged-in': !isLoggedIn }" aria-hidden="true">
          <use xlink:href="#icon-yonghu"></use>
        </svg>
        <span v-if="!isLoggedIn" class="login-status">未登录</span>
      </div>
      <div v-if="isUserMenuVisible && isLoggedIn" class="user-menu">
        <div class="user-profile">
          <div class="user-avatar">
            <img :src="userAvatar || 'https://img.inkmaster.cn/logo/inkmaster.png'" alt="Avatar" class="avatar-img">
          </div>
          <div class="user-info">
            <div class="user-name" v-html="nickName"></div>
            <div class="upgrade-promo">
              <a class="upgrade-link" @click="showUpgradeModal">
                升级 Plus 会员享专属特权
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" class="arrow-icon">
                  <path fill-rule="evenodd" d="M9.293 7.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L13.586 12 9.293 7.707z" clip-rule="evenodd"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div class="quick-access-grid">
          <a href="/problem-list" class="grid-item">
            <div class="grid-icon">
              <img src="https://static.leetcode.cn/cn-frontendx-assets/production/_next/static/images/list-a671ce9b1030394bb8b1b3d433e1199c.png" alt="list">
            </div>
            <div class="grid-label">题单</div>
          </a>
          <a href="/collection" class="grid-item">
            <div class="grid-icon">
              <img src="https://static.leetcode.cn/cn-frontendx-assets/production/_next/static/images/starred-2e4c5ddcac0ba3a09087d8ff98eff50c.png" alt="myList">
            </div>
            <div class="grid-label">收藏夹</div>
          </a>
          <a href="/progress" class="grid-item">
            <div class="grid-icon">
              <img src="https://static.leetcode.cn/cn-frontendx-assets/production/_next/static/images/progress-106c8d8956a5f08d22006a6ea911e6c3.png" alt="progress">
            </div>
            <div class="grid-label">进展分析</div>
          </a>
        </div>

        <ul class="menu-list">
          <li class="menu-item" @click="toUserInfo">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-yonghu"></use>
            </svg>
            <span>账号设置</span>
          </li>
          <!-- <li class="menu-item theme-switcher">
            <div class="theme-header" @click="toggleThemeMenu">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-theme"></use>
              </svg>
              <span>外观</span>
              <svg class="arrow-icon" :class="{ 'rotate': isThemeMenuOpen }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
                <path fill-rule="evenodd" d="M9.293 7.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L13.586 12 9.293 7.707z" clip-rule="evenodd"></path>
              </svg>
            </div>
            <ul class="theme-options" v-if="isThemeMenuOpen">
              <li :class="{ active: theme === 'system' }" @click="setTheme('system')">跟随系统</li>
              <li :class="{ active: theme === 'light' }" @click="setTheme('light')">浅色</li>
              <li :class="{ active: theme === 'dark' }" @click="setTheme('dark')">深色</li>
            </ul>
          </li> -->
          <li class="menu-item" @click="logout">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-Frame"></use>
            </svg>
            <span>退出登录</span>
          </li>
        </ul>
      </div>
    </div>
    <FlipCard v-if="showLoginModal" @close="showLoginModal = false" />
  </nav>
</template>

<script>
import FlipCard from '@/views/misc/FlipCard.vue';

export default {
  name: 'TopNavBar',
  components: {
    FlipCard
  },
  data() {
    return {
      isUserMenuVisible: false,
      isLoggedIn: false,
      nickName: '',
      userAvatar: '',
      showLoginModal: false,
      theme: 'system',
      isThemeMenuOpen: false
    };
  },
  mounted() {
    this.checkLoginStatus();
  },
  methods: {
    toggleUserMenu() {
      this.isUserMenuVisible = !this.isUserMenuVisible;
    },
    checkLoginStatus() {
      const token = localStorage.getItem('token');
      if (token) {
        this.isLoggedIn = true;
        this.nickName = localStorage.getItem('nickName');
        this.userAvatar = localStorage.getItem('userAvatar');
      } else {
        this.isLoggedIn = false;
      }
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('userAvatar');
      localStorage.removeItem('nickName');
      this.isLoggedIn = false;
      this.isUserMenuVisible = false;
    },
    showLogin() {
      this.showLoginModal = true;
    },
    toUserInfo() {
      this.$router.push('/user/info');
    },
    showUpgradeModal() {
      // TODO: Implement upgrade modal
    },
    toggleThemeMenu() {
      this.isThemeMenuOpen = !this.isThemeMenuOpen;
    },
    setTheme(theme) {
      this.theme = theme;
      // TODO: Implement theme switching logic
    }
  }
};
</script>

<style scoped>
.top-nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  height: 75px;
}

.nav-left {
  display: flex;
  position:absolute;
  left: 10%;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 1.5em;
  font-weight: bold;
  color: #333;
  margin-right: 20px;
}

.logo svg {
  margin-right: 10px;
}

.divider {
  width: 1px;
  height: 30px;
  background-color: #ccc;
  margin-right: 20px;
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links li {
  margin: 0 10px;
}

.nav-links a {
  text-decoration: none;
  color: #777E90;
  font-size: 1em;
  transition: color 0.3s ease;
}

.nav-links a:hover {
  color: #000;
}

.user-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.user-icon {
  font-size: 1.5em;
  color: #555;
  cursor: pointer;
  position: absolute;
  right: 8%;
}

.user-icon svg {
  width: 24px;
  height: 24px;
}

.user-icon .not-logged-in {
  color: #ff4d4f;
}

.login-status {
  font-size: 12px;
  color: #ff4d4f;
  font-weight: 500;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
}

.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  overflow: hidden;
  z-index: 1001;
  width: 320px;
  font-size: 14px;
  text-align: left;
  padding: 16px;
  margin-top: 8px;
}

.user-profile {
  display: flex;
  align-items: center;
  padding: 16px;
  margin: -16px -16px 16px -16px;
  background-color: #f7f7f7;
}

.user-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.upgrade-promo {
  display: flex;
  align-items: center;
}

.upgrade-link {
  color: #ff9500;
  font-size: 12px;
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.arrow-icon {
  width: 14px;
  height: 14px;
  margin-left: 4px;
}

.quick-access-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
  position: relative;
}

.quick-access-grid::after {
  content: "coming soon";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.727);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #777e90;
  font-weight: bold;
  backdrop-filter: blur(1px);
  z-index: 3;
}

.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background-color: #f7f7f7;
  border-radius: 13px;
  text-decoration: none;
  transition: background-color 0.2s;
}

.grid-item:hover {
  background-color: #f0f0f0;
}

.grid-icon {
  width: 36px;
  height: 36px;
  margin-bottom: 8px;
}

.grid-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.grid-label {
  font-size: 12px;
  color: #777e90;
}

.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s;
  color: #777e90;
}

.menu-item:hover {
  background-color: #f7f7f7;
}

.menu-item .icon {
  width: 18px;
  height: 18px;
  margin-right: 12px;
}

.menu-item span {
  flex: 1;
}

.theme-switcher {
  position: relative;
}

.theme-header {
  display: flex;
  align-items: center;
  width: 100%;
}

.arrow-icon.rotate {
  transform: rotate(90deg);
}

.theme-options {
  list-style: none;
  padding: 0;
  margin: 8px 0 0 0;
  background-color: #f7f7f7;
  border-radius: 8px;
  overflow: hidden;
}

.theme-options li {
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.theme-options li:hover {
  background-color: #f0f0f0;
}

.theme-options li.active {
  color: #1a1a1a;
  font-weight: 500;
}
</style>
